import type { ReactNode } from 'react';

import ErrorIcon from '@/assets/svg/bx-error.svg?react';
import { Text } from '@/components/typography';

type Props = {
  title: ReactNode;
  children?: ReactNode;
};

const HealthCheckError = ({ title, children }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-start gap-2">
        <ErrorIcon className="-mt-0.5 h-6 w-6 shrink-0 text-red-400" />
        <Text variant="body1">{title}</Text>
      </div>
      {children && (
        <div className="ml-8 flex flex-col gap-2 border-l-4 border-red-400 py-2 pl-4">
          {children}
        </div>
      )}
    </div>
  );
};

export default HealthCheckError;
